import * as React from 'react';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import useDrive from "../../hooks/useDrive";
import useNotification from "../../hooks/useNotification";
import FileService from "../../services/FileService";
import AppUiDialogTitle from "../AppUiComponents/AppUiDialogTitle";
import {Typography} from "@mui/material";
import DriveService from "../../services/DriveService";
import {DRIVE_TYPES} from "../../config/appConst";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        minWidth: "40vw"
    }
}));


function FileUncompressDialog(props) {
    const {open, setOpen, row} = props;
    const {CurrentDrive, changeCurrentDrive, changeDeleteKey} = useDrive();
    const {addNotification} = useNotification();
    const handleClose = () => {
        setOpen(false);
    };

    const submit = async () => {
        const {parent} = CurrentDrive;
        const path = parent && parent !== "" && parent !== "/" ? parent + "/" + row.Key : row.Key;

        await FileService.uncompress({files: [path]}, CurrentDrive.driveType);
    
        addNotification({type: "success", message: (row.type.charAt(0).toUpperCase() + row.type.slice(1)) + " uncompressed successfully"});
        const drive = await DriveService.getFileTree(parent, CurrentDrive.driveType);
        // changeCurrentDrive({parent, drive});
        if (CurrentDrive.driveType === DRIVE_TYPES.SHARED) {
            changeCurrentDrive({parent, drive: {}, sharedDrive: drive, driveType: CurrentDrive.driveType});
        } else {
            changeCurrentDrive({parent, drive});
        }
        handleClose();
    }
    return (
        <div>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="file-folder-delete-dialog-title"
                open={open}
            >
                <AppUiDialogTitle id="file-exist-dialog-title" onClose={handleClose}>
                    {row.type.charAt(0).toUpperCase() + row.type.slice(1)} Uncompress Confirmation
                </AppUiDialogTitle>
                <DialogContent dividers>
                    <Box noValidate sx={{mt: 1}}>
                       <Typography>
                           Are you sure you want uncompress this {row.type} ?
                       </Typography>
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus onClick={handleClose}>
                        no
                    </Button>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus onClick={submit}
                            type="submit"
                    >
                        Yes
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

FileUncompressDialog.propTypes = {}
export default FileUncompressDialog;